import { type FC } from 'react';
import { useSelector } from 'react-redux';

import { type RootState } from '@editor2/reducers/root';
import ChangesHeader from './common/ChangesHeader';
import { getElementHumanName, getElementPreview } from '@editor2/services/elementService';
import { getPageNumberIfExistsAndNotSpace } from '@editor2/services/pagesService';
import { getPageOrdinalNumber } from '@editor2/services/numberingService';
import { getPageByElementId } from '../CourseChangesDiff/helpers';

interface Props {
	courseId: number;
	elementId: string;
}

const ElementsChanges: FC<Props> = (props) => {
	const { elementId, courseId } = props;

	const { changes, pages, elements, initialCourse, config } = useSelector(
		(state: RootState) => state.courses[courseId]
	);
	const courseState = useSelector((state: RootState) => state.courses[courseId]);

	const changesStatuses = changes.elements[elementId];
	const currentElement = elements.entities[elementId];
	const initialElement = initialCourse.elements?.entities[elementId];

	const getElementHeader = () => {
		const entity = currentElement || initialElement;
		const parentPage =
			getPageByElementId(pages, elementId) || getPageByElementId(initialCourse.pages, elementId);

		// next try-cath block is added as a temporary fix for Safari after-save update issue
		// when parentPage is undefined - which is never expected
		let pageNumber;

		try {
			pageNumber =
				getPageNumberIfExistsAndNotSpace(parentPage) ||
				`#${getPageOrdinalNumber(courseState, parentPage.family_id)}`;
		} catch (error) {
			console.error(error);
			if (window.Rollbar) window.Rollbar.error(error);
		}

		const elementHumanName = getElementHumanName(config, parentPage.page_type, entity);
		return `Page ${pageNumber}: ${elementHumanName}`;
	};

	const getElementPreviewText = () => {
		const entity = currentElement || initialElement;
		const preview = getElementPreview(entity);

		return preview;
	};

	return (
		<div className="changeBlock">
			<ChangesHeader changesStatuses={changesStatuses} headerTitle={getElementHeader()} />
			<div className="elementPreview">{getElementPreviewText()}</div>
		</div>
	);
};

export default ElementsChanges;
